import { useState } from 'react';

/**
 * Componente optimizado para mostrar imagen del circuito de F1 con fallback automático
 * Cambia automáticamente a imagen por defecto cuando la imagen original falla al cargar
 * 
 * @param {Object} props - Propiedades del componente
 * @param {Object} props.race_results - Datos de los resultados de la carrera
 * @param {string} props.race_results.circuit_image - URL de la imagen del circuito
 * @param {string} props.venue_name - Nombre del venue/circuito para el alt text
 * 
 * @returns {JSX.Element} Contenedor con imagen del circuito o fallback CSS
 * 
 * @example
 * <CircuitImage 
 *   race_results={{ circuit_image: 'https://example.com/circuit.jpg' }}
 *   venue_name="Monaco"
 * />
 */
export default function CircuitImage({ race_results, venue_name }) {
  const [isDefaultImage, setIsDefaultImage] = useState(false);
  
  // Validaciones de seguridad
  const circuitImageUrl = race_results?.circuit_image;
  const altText = venue_name ? `Circuito ${venue_name}` : 'Circuito de F1';
  
  // Si no hay URL de imagen, usar directamente el fallback
  if (!circuitImageUrl) {
    return (
      <div className="trail-f1-default">
        <div className="img-trail-f1-default" />
      </div>
    );
  }

  return (
    <div className={`trail-f1${isDefaultImage ? '-default' : ''}`}>
      <div className={`img-trail-f1${isDefaultImage ? '-default' : ''}`}>
        {!isDefaultImage && (
          <img
            src={circuitImageUrl}
            alt={altText}
            loading="lazy"
            onError={() => setIsDefaultImage(true)}
          />
        )}
      </div>
    </div>
  );
}